module.exports = __webpack_public_path__ + "static/RobotoMono-Light-b82d827ba127c43e9272942682b88dc3.ttf";